/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OutputUavParsePreviewCatalog
 */
export interface OutputUavParsePreviewCatalog {
    /**
     * 
     * @type {number}
     * @memberof OutputUavParsePreviewCatalog
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof OutputUavParsePreviewCatalog
     */
    name?: string;
    /**
     * 
     * @type {boolean}
     * @memberof OutputUavParsePreviewCatalog
     */
    needsReview?: boolean;
    /**
     * 
     * @type {string}
     * @memberof OutputUavParsePreviewCatalog
     */
    reason?: string;
    /**
     * WouldCreate — у бойовому прогоні тут був би створений новий запис довідника. На стенді
     * запис не створюється, тож ID лишається null (а екіпаж шукається без звуження по підрозділу).
     * @type {boolean}
     * @memberof OutputUavParsePreviewCatalog
     */
    wouldCreate?: boolean;
}

/**
 * Check if a given object implements the OutputUavParsePreviewCatalog interface.
 */
export function instanceOfOutputUavParsePreviewCatalog(value: object): boolean {
    return true;
}

export function OutputUavParsePreviewCatalogFromJSON(json: any): OutputUavParsePreviewCatalog {
    return OutputUavParsePreviewCatalogFromJSONTyped(json, false);
}

export function OutputUavParsePreviewCatalogFromJSONTyped(json: any, ignoreDiscriminator: boolean): OutputUavParsePreviewCatalog {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'needsReview': json['needsReview'] == null ? undefined : json['needsReview'],
        'reason': json['reason'] == null ? undefined : json['reason'],
        'wouldCreate': json['wouldCreate'] == null ? undefined : json['wouldCreate'],
    };
}

export function OutputUavParsePreviewCatalogToJSON(value?: OutputUavParsePreviewCatalog | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'name': value['name'],
        'needsReview': value['needsReview'],
        'reason': value['reason'],
        'wouldCreate': value['wouldCreate'],
    };
}

